import React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Divider } from '@mui/material';
import { WarningAmber, CheckCircle, ErrorOutline } from '@mui/icons-material';
import PropTypes from 'prop-types';

export function MMessageBoard({ title, open, onClose, body, footer, minWidth, warning, success, error, width, maxWidth, headerButton }) {

    function iconFunc() {
        if (error) {
            return <ErrorOutline style={{ color: 'var(--color-red)', marginRight: '10px' }} />
        } else if (warning) {
            return <WarningAmber style={{ color: 'var(--color-yellow)', marginRight: '10px' }} />
        } else if (success) {
            return <CheckCircle style={{ color: 'var(--color-green)', marginRight: '10px' }} />
        }
        return null
    }

    return (
        <Dialog open={open} onClose={onClose} PaperProps={{ sx: { maxWidth: maxWidth, minWidth: minWidth, width: width, zIndex: '10', position: 'sticky' }, 'data-testid': 'paper' }}>
            <DialogTitle style={{ display: 'flex', alignItems: 'center' }}>
                {iconFunc()}
                <b style={{ color: 'var(--color-black)' }}>
                    {title}
                </b>
                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>{headerButton}</div>
            </DialogTitle>
            <Divider />
            <DialogContent style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                {body}
            </DialogContent>
            <Divider />
            {footer ? (
                <DialogActions style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '64px' }}>
                    {footer}
                </DialogActions>
            ) : null}
        </Dialog>
    )
}

MMessageBoard.propTypes = {
    title: PropTypes.node,
    open: PropTypes.bool,
    onClose: PropTypes.func,
    body: PropTypes.node,
    footer: PropTypes.node,
    minWidth: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number,
    ]),
    warning: PropTypes.bool,
    success: PropTypes.bool,
    error: PropTypes.bool,
    width: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number,
    ]),
    maxWidth: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number,
    ]),
    headerButton: PropTypes.node
}